'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../typography/ErrorText/ErrorText.js');
require('../typography/LargeDarkText/LargeDarkText.js');
require('../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../typography/MediumDarkText/MediumDarkText.js');
require('../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../typography/MediumText/MediumText.js');
require('../typography/MediumWhiteText/MediumWhiteText.js');
require('../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../typography/SmallDarkText/SmallDarkText.js');
require('../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../typography/SmallDisabledText/SmallDisabledText.js');
var SmallEmphasizedDarkText = require('../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../typography/SmallLinkText/SmallLinkText.js');
var SmallTitleText = require('../typography/SmallTitleText/SmallTitleText.js');
require('../typography/SmallWhiteText/SmallWhiteText.js');
require('../typography/TinyDarkText/TinyDarkText.js');
require('../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../typography/TinyLinkText/TinyLinkText.js');
require('../typography/TinyTitleText/TinyTitleText.js');
require('../typography/XXLargeDarkText/XXLargeDarkText.js');
var styledComponents = require('./styled-components.js');

var IconAvatar = function (props) {
    var icon = props.icon, title = props.title, info = props.info, description = props.description;
    return (React__default.createElement(styledComponents.IconAvatarContainer, null,
        React__default.createElement("div", { style: { paddingRight: '1rem' } }, icon),
        React__default.createElement("div", null,
            React__default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                typeof title === 'string' && React__default.createElement(SmallEmphasizedDarkText, null, title),
                typeof title !== 'string' && title,
                "\u2002",
                React__default.createElement(SmallTitleText, null, info)),
            React__default.createElement("div", null,
                React__default.createElement(SmallDarkText, null, description)))));
};

module.exports = IconAvatar;
